<template>
  <b-card
    no-body
    class="card-payment"
  >
    <b-card-body>
      <!-- form -->
      <b-form>
        <b-row>
          <b-col sm="6">
            <b-form-group
              label="Institución"
              label-for="institucion"
            >
              <b-form-select
                v-model="institucion"
                type="select"
                class="custom-select"
                @change="onChangeInstitucion"
              >
                <option
                  value=""
                >
                  SELECCIONE::
                </option>
                <option
                  v-for="inst in optionInstitucion"
                  :key="inst.idInstitucion"
                  :value="inst.idInstitucion"
                >
                  {{ inst.nombre }}
                </option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              label="Dependencia"
              label-for="proyecto"
            >
              <b-form-select
                v-model="proyecto"
                type="select"
                class="custom-select"
              >
                <option value="">
                  SELECCIONE::
                </option>
                <option
                  v-for="proy in optionProyecto"
                  :key="proy.idProyecto"
                  :value="proy.idProyecto"
                >
                  {{ proy.nombre }}
                </option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <!--/ form -->
    </b-card-body>
  </b-card>
</template>

<script>
import store from '@/store'
import {
  BCard, BCardBody, BRow, BCol, BFormGroup, BForm, BFormSelect,
} from 'bootstrap-vue'
import { showToast } from '@/helpers'

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormSelect,
  },
  emits: ['update:is-busy-clonar', 'update:modal-show', 'update:data-edit'],
  props: {
    typeAction: {
      type: String,
      required: true,
    },
    dataClone: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      type: '',
      institucion: '',
      optionInstitucion: [],
      proyecto: '',
      optionProyecto: [],
      isBusy: false,
    }
  },
  mounted() {
    this.dataForm()
  },
  methods: {
    async saveForm() {
      let bval = true
      this.isBusy = true
      console.log('guardando desde modal..')
      if (bval && this.institucion === '') {
        this.showToast('Advertencia', 'Seleccione una institución', 'warning')
        bval = false
        this.isBusy = false
      }
      if (bval && this.proyecto === '') {
        this.showToast('Advertencia', 'Seleccione una dependencia', 'warning')
        bval = false
        this.isBusy = false
      }

      if (bval) {
        const formData = {
          idProyecto: this.proyecto,
          idEncuesta: this.dataClone.idEncuesta,
        }
        await store.dispatch('gsencuesta/ENCUESTA_CLONE', formData)
          .then(response => {
            this.isBusy = false
            this.$emit('refetch-data', response)
            this.$emit('update:modal-show', false)
          })
          .catch(error => {
            this.isBusy = false
            this.$emit('error-data', error)
          })
        this.$emit('update:is-busy-clone', false)
      }
    },
    onChangeInstitucion() {
      this.proyecto = ''
      this.dataProyecto(this.institucion)
    },
    dataProyecto(institucion) {
      store
        .dispatch('gsencuesta/PROYECTO_FIND_ALL', {
          limit: -1,
          query: '',
          page: -1,
          sortBy: '',
          idInstitucion: institucion,
        })
        .then(response => {
          if (response !== undefined) {
            this.optionProyecto = response
          }
        })
        .catch(() => {
        })
    },
    dataForm() {
      store
        .dispatch('gsencuesta/INSTITUCION_FIND_ALL', {
          limit: -1,
          query: '',
          page: -1,
          sortBy: '',
        })
        .then(response => {
          if (response !== undefined) {
            this.optionInstitucion = response
          }
        })
        .catch(error => {
          this.showToast('Ha ocurrido un error', error, 'danger')
        })
    },
    showToast,
  },
}
</script>
